import { render, staticRenderFns } from "./VenuePublication.vue?vue&type=template&id=e07c18ba"
import script from "./VenuePublication.vue?vue&type=script&lang=ts"
export * from "./VenuePublication.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports